import { createContext, useContext } from 'react';

export interface ListKeepAliveState {
  /** False while the list is hidden underneath one of its view / edit pages. */
  isShowing: boolean;
}

// A list rendered outside a ListKeepAlive is simply always showing.
export const ListKeepAliveContext = createContext<ListKeepAliveState>({ isShowing: true });

export const useListKeepAlive = () => useContext(ListKeepAliveContext);
